/** Shared layout tokens aligned to the PRO-183 scorecard mocks. */

export const SCORECARD_PANEL_SECTION_LABEL =
  "text-[11px] font-medium uppercase tracking-[0.08em] text-muted-foreground";

export const SCORECARD_CARD =
  "overflow-hidden rounded-lg border border-border/70 bg-background shadow-[0_1px_2px_rgba(0,0,0,0.04)]";

export const SCORECARD_ROW_DIVIDER = "border-b border-border/60 last:border-b-0";

export const SCORECARD_EVALUATOR_GRID =
  "grid grid-cols-[repeat(auto-fit,minmax(300px,1fr))] items-stretch gap-2";

export const SCORECARD_EVALUATOR_CARD =
  "overflow-hidden rounded-lg border border-border/60 bg-background shadow-[0_1px_2px_rgba(0,0,0,0.03)] transition-[border-color,box-shadow] hover:border-foreground/15 hover:shadow-[0_2px_5px_rgba(0,0,0,0.05)]";

export const SCORECARD_DETAIL_TITLE =
  "min-w-0 break-words text-base font-semibold leading-6 text-foreground";

export const SCORECARD_AGGREGATE_SCORE =
  "text-[2rem] font-semibold leading-none tabular-nums text-foreground";

export const SCORECARD_VERDICT_PILL =
  "inline-flex shrink-0 items-center whitespace-nowrap rounded-full border px-2.5 py-0.5 text-[11px] font-medium";

export const SCORECARD_FIELD_LABEL =
  "text-[11px] font-medium uppercase tracking-[0.08em] text-muted-foreground";

export const SCORECARD_VERDICT_TONES = {
  pass: {
    dot: "bg-emerald-500",
    badge: "border-emerald-200 bg-emerald-50 text-emerald-700",
    progress: "bg-emerald-500",
  },
  warn: {
    dot: "bg-amber-500",
    badge: "border-amber-200 bg-amber-50 text-amber-700",
    progress: "bg-amber-500",
  },
  fail: {
    dot: "bg-red-500",
    badge: "border-red-200 bg-red-50 text-red-700",
    progress: "bg-red-500",
  },
  stale: {
    dot: "bg-amber-500",
    badge: "border-amber-200 bg-amber-50 text-amber-700",
    progress: "bg-amber-400",
  },
  neutral: {
    dot: "bg-muted-foreground/40",
    badge: "border-border bg-muted/40 text-muted-foreground",
    progress: "bg-muted-foreground/30",
  },
} as const;

export const SCORECARD_DEFAULT_LLM_ASSERTION_PROMPT =
  "Is this output high quality and correct? Answer true or false.";

export const SCORECARD_DEFAULT_CODE_BY_LANGUAGE = {
  PYTHON: `# Access row values by column name from data.
# Example: output = data.get("Output")
return True`,
  JAVASCRIPT: `// Access row values by column name from data.
// Example: const output = data["Output"];
return true;`,
} as const;

export const SCORECARD_DEFAULT_CODE = SCORECARD_DEFAULT_CODE_BY_LANGUAGE.PYTHON;

export const SCORECARD_DEFAULT_REGEX_PATTERN = ".*";

export const SCORECARD_DEFAULT_ASSERT_VALID_TYPE = "object";
